import { language } from '../constants/language';
import { LanguageEnum } from '../enums/language.enum';
import { LanguageKeys } from '../models/language/language';

export const enumToCode = (lang: LanguageEnum) => Object.values(language).find((item) => item.id === lang)?.key || '';

export const codeToEnum = (lang: LanguageKeys) => language[lang].id;
